/**
 * The most characters a promo badge or chip may take on a product card.
 * The back office allows 50 (the stored value is untouched); only the
 * display is capped, so a long "Display badge" cannot push the card apart.
 * Mirrored in bo_autopia `src/lib/promo-badge.ts` (the editor's warning),
 * and in the web shop and kiosk `catalog-promo.js` — keep them in step.
 */
export const BADGE_DISPLAY_MAX = 12;

/**
 * Trimmed, and cut to `BADGE_DISPLAY_MAX` with a trailing "…" when longer
 * (the ellipsis counts toward the limit). Counted by code point, so an
 * emoji is never split in half.
 */
export function shortBadge(text: string | null | undefined): string {
  const chars = Array.from((text ?? '').trim());
  if (chars.length <= BADGE_DISPLAY_MAX) return chars.join('');
  return `${chars.slice(0, BADGE_DISPLAY_MAX - 1).join('').trimEnd()}…`;
}
